<div class="contactUsPopup">
    <form [formGroup]="feedbackForm" (submit)="onSubmitClick()" *ngIf="!feedbackSubmitted">
      <div class="contactUsHeader">
        <h2>Was the result accurate?</h2>
        <span class="like-dislike-container">
          <span [ngClass]="[isLiked ? 'selected-btn' : '', 'feedback-like-icon']" (click)="isLiked = true"></span>
          <span [ngClass]="[!isLiked ? 'selected-btn' : '', 'feedback-dislike-icon']" (click)="isLiked = false"></span>
        </span>
      </div>
      <div class="contactUsBody">
        <h3>사용한 입력 텍스트에 대해 말씀해주시겠습니까?</h3>
        <ul>
          <li *ngFor="let option of options; index as index">
            <span [ngClass]="[selectedOptionNumber === index ? 'selected-option' : '', 'feedback-option']" (click)="selectedOptionNumber = index">
                <span class="feedback-option-checkbox"></span>
                <span class="feedback-option-txt">{{option.text}}</span>
            </span>
          </li>
        </ul>
        <textarea matInput formControlName="feedbackText" placeholder="피드백이나 제안 사항이 있습니까?"
        class="feedback-textarea"></textarea>
      </div>
      <div class="contactUsFooter">
        <button class="contactusCloseButton" mat-button mat-dialog-close>취소</button>
        <button type="submit" class="contactUsSubmitButton" [disabled]="selectedOptionNumber === -1">제출</button>
      </div>
    </form>
    <div class="feedbackThankYou" *ngIf="feedbackSubmitted">
      <div class="SVGwrapper">
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
      </div>
      <h2 class="animate__animated animate__fadeInUp animate__delay-1s">피드백을 공유해주셔서 감사합니다!</h2>
      <button class="contactusCloseButton animate__animated animate__fadeInUp animate__delay-1s" class="contactusCloseButton" mat-button mat-dialog-close>종료</button>
    </div>
  </div>
  